module.exports = __webpack_public_path__ + "static/media/Egyptian Warrior.b700e6e0.jpg";